import MenuContent from './MenuContent';

export default MenuContent;
